import { useState } from "react";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import api from "api/config";

const RolePermissionsUpdater = () => {
  const [roleName, setRoleName] = useState("");
  const [jsonInput, setJsonInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    let payload;

    try {
      payload = JSON.parse(jsonInput);
    } catch {
      setError("Invalid JSON format");
      return;
    }

    if (!roleName) {
      setError("Role name is required");
      return;
    }

    try {
      setLoading(true);
      // return console.log("payload ===>", payload);
      await api({
        method: "PUT",
        url: "/api/v1/roles/default-permissions",
        data: {
          role: roleName,
          permissions: payload,
        },
      });

      setSuccess("Role permissions updated successfully");
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to update role permissions");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <VuiBox p={3}>
        {/* Header */}
        <VuiBox>
          <VuiTypography variant="lg">Update Role Permissions</VuiTypography>
        </VuiBox>

        <VuiBox mb={2}>
          <VuiTypography variant="caption">
            Paste valid JSON to update role permissions directly
          </VuiTypography>
        </VuiBox>

        {/* Role Name */}
        <VuiBox mb={2}>
          <VuiTypography variant="caption">Role Name</VuiTypography>
          <VuiInput
            placeholder="Super Admin"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
          />
        </VuiBox>

        {/* Permissions JSON */}
        <VuiBox mb={2}>
          <VuiTypography variant="caption">Permissions</VuiTypography>
          <VuiInput
            multiline
            rows={10}
            placeholder={`{
  "permissions": ["viewDashboard", "editGuests"]
}`}
            value={jsonInput}
            onChange={(e) => setJsonInput(e.target.value)}
            inputProps={{ maxLength: 10000 }}
          />
        </VuiBox>

        {/* Feedback */}
        {error && (
          <VuiTypography variant="caption" color="error" mb={1}>
            {error}
          </VuiTypography>
        )}

        {success && (
          <VuiTypography variant="caption" color="success" mb={1}>
            {success}
          </VuiTypography>
        )}

        {/* Action */}
        <VuiBox display="flex" justifyContent="flex-end">
          <VuiButton color="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? <CircularProgress size={18} /> : "Update Permissions"}
          </VuiButton>
        </VuiBox>
      </VuiBox>
    </Card>
  );
};

export default RolePermissionsUpdater;
